// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d3c7d20","396":"b54e3c76","455":"c0eac7bb","977":"e6db39a3"}[chunkId] + ".chunk.js";
};